
export default function TargetAreasSection() {
  return (
    <section id="areas" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Specific Areas We Target in El Paso & Southern New Mexico
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We actively purchase land throughout the El Paso region. Here's what makes each area unique and what we look for when buying there.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Horizon City</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> One of El Paso's fastest-growing areas. Residential development is booming, with new subdivisions constantly breaking ground.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Residential lots (0.25-1 acre), small acreage parcels (1-5 acres), and land near new development.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> Strong appreciation potential as El Paso expands eastward. Good schools and newer infrastructure attract families.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Chaparral, NM</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> Unincorporated community in Doña Ana County. Lower property taxes than Texas attract buyers seeking affordable land.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Rural acreage (5-40 acres), mobile home lots, and off-grid properties.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> Affordable entry point for homesteaders and RV owners. Minimal building restrictions in unincorporated areas.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">East El Paso</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> Established neighborhoods with occasional infill lots. Mix of older and newer developments.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Infill lots in established neighborhoods, small parcels near schools and shopping.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> Utilities in place, good schools, and strong demand from custom home builders.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Far East El Paso</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> The frontier of El Paso's growth. Raw land transitioning from agricultural to residential use.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Large parcels (5-20 acres) suitable for future subdivision, agricultural land in the path of growth.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> Long-term appreciation as the city expands. Lower current prices with high upside potential.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Anthony, TX/NM</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> Small border town straddling Texas and New Mexico. Agricultural heritage with growing residential development.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Agricultural land, small ranches (10-40 acres), and residential lots.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> Affordable land prices, agricultural exemptions available, and proximity to both El Paso and Las Cruces.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-map-pin-fill text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Northeast El Paso</h3>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Market Overview:</strong> Affluent area with larger lots and custom homes. Some of El Paso's most desirable neighborhoods.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What we buy:</strong> Premium infill lots (0.5-2 acres), view lots in the foothills, and estate-sized parcels.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Why it's valuable:</strong> High-end market with strong demand. Mountain views and larger lots command premium prices.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-lg mb-12">
          <h3 className="text-3xl font-bold mb-6 text-gray-900">Other Areas We Serve</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h4 className="text-xl font-bold mb-3 text-teal-600">Texas</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Socorro, TX - Growing community east of El Paso</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>San Elizario, TX - Historic town with agricultural land</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Clint, TX - Rural community with ranch land</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Fabens, TX - Agricultural area near the border</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Tornillo, TX - Rural land and small ranches</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-3 text-teal-600">New Mexico</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Sunland Park, NM - Border community with growth potential</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Santa Teresa, NM - Industrial and residential development</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Berino, NM - Agricultural land and small parcels</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Vado, NM - Rural community with affordable land</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line text-teal-600 mr-2 mt-1"></i>
                  <span>Mesquite, NM - Unincorporated area with large parcels</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-lg p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Don't See Your Area Listed?</h3>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed text-teal-50">
            We buy land throughout El Paso County, Texas and Doña Ana County, New Mexico. Even if your property isn't in one of the areas listed above, contact us. We evaluate every property individually and make offers based on its unique characteristics.
          </p>
          <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-teal-600 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-phone-fill"></i>
            <span>Call About Your Property: (915) 206-5814</span>
          </a>
        </div>
      </div>
    </section>
  );
}
